<template>
  <div>
    <portal to="countryAdministrationHeaderRightSide">
      <div class="d-flex align-center">
        <v-btn
          v-if="haveAccessToRequestTool"
          :to="{name: 'reqTool', params: {countryId: countryId}}"
          class="mx-1"
          link
        >
          {{ $t('Request Tool') }}
        </v-btn>

        <v-btn
          :to="{name: 'CountryEquipment', params: {countryId: countryId}}"
          class="mx-1"
          link
        >
          {{ $t('Equipment') }}
        </v-btn>
        <v-btn
          :to="{name: 'CountryWorkload', params: {countryId: countryId}}"
          class="mx-1"
          link
        >
          {{ $t('Workload and Shortage') }}
        </v-btn>
      </div>
    </portal>

    <v-row class="white">
      <v-col cols="12">
        <v-card class="my-3">
          <v-card-text>
            <h3 class="my-2">
              {{ $t('Laboratories') }}
            </h3>
            <level-of-service-labs :laboratories="laboratories" />
          </v-card-text>
        </v-card>
        <Laboratories :laboratories="laboratories" />
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-text>
            <laboratory-training-statistics
              :laboratories="laboratories"
              :training-sessions="laboratoriesTrainingInfo.trainingSessions || []"
              :training-modules="laboratoriesTrainingInfo.trainingModules || []"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-text>
            <laboratory-supervision-statistics :laboratories="laboratories" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        v-if="country"
        cols="12"
      >
        <v-card>
          <v-card-text>
            <laboratory-equipment-statistics
              :laboratories="laboratories"
              :country="country"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-text>
            <workload-dashboard-statistics :workload-data="workloadData" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Me from "@/mixins/Me";
import Country from "@/mixins/Country";
import Laboratory from "@/mixins/laboratory/Laboratory";

import Laboratories from "@/components/administration/Laboratories";
import LaboratoryTrainingStatistics from "@/components/training/LaboratoryTrainingStatistics";
import LaboratorySupervisionStatistics from "@/components/supervision/LaboratorySupervisionStatistics";
import LaboratoryEquipmentStatistics from "@/components/equipment/LaboratoryEquipmentStatistics";
import LevelOfServiceLabs from "@/components/administration/LevelOfServiceLabs";
import WorkloadDashboardStatistics from "@/components/workload/WorkloadDashboardStatistics";


import {mapActions} from 'vuex';

export default {
  name: "CountryAdministrationView",

  components: {
    Laboratories,
    LaboratoryTrainingStatistics,
    LaboratorySupervisionStatistics,
    LaboratoryEquipmentStatistics,
    LevelOfServiceLabs,
    WorkloadDashboardStatistics
  },

  mixins: [
    Me,
    Country,
    Laboratory
  ],

  data: () => {
    return {
      workloadData: []
    }
  },

  computed: {
    countryId() {
      return this.$route.params.countryId
    },

    haveAccessToRequestTool() {
      return this.checkRole('RT', 0)
    }
  },

  // created() {
  // TODO check access
  // },

  mounted() {
    this.awaitPromiseCallback({
      key: 'getMe', cb: async () => {
        this.setGlobalLoading(true);
        // if (!this.checkRole('', 0)) {
        //     await this.$router.push({name: 'Home'})
        // } else {
        try {
          await this.getCountryById(this.countryId);
          await this.getLaboratoriesByCountry(this.countryId);
          if (this.laboratories?.length) {
            await this.workloadGetByLabs(this.laboratories.map(lab => lab.id)).then(res => {
              this.workloadData = res.data;
              this.workloadData.forEach(workload => {
                workload.laboratory = this.laboratories.find(lab => lab.id == workload.laboratory)
              })
            });
          }

        } catch (e) {
          // TODO: handle error router back or 404
          console.error(e)
        }
        // }
        this.setGlobalLoading(false);
      }
    });
  },

  methods: {
    ...mapActions('workload', {
      workloadGetByLabs: 'getByLabs',
    }),
  }

}
</script>

<style scoped>

</style>
